"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../../../shared");

var HeadRow_meta_1 = require("./HeadRow.meta");

var TableComponentBase_1 = require("../TableComponentBase");

var HeadCell_1 = __importDefault(require("../HeadCell"));

var HeadRow =
/** @class */
function (_super) {
  __extends(HeadRow, _super);

  function HeadRow(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = HeadRow_meta_1.HEAD_ROW_CATEGORY_KEY;
    _this.componentKey = HeadRow_meta_1.HEAD_ROW_COMPONENT_KEY;
    return _this;
  }

  Object.defineProperty(HeadRow.prototype, "parentComponentKey", {
    get: function get() {
      return HeadRow_meta_1.HEAD_ROW_PARENT_COMPONENT_KEY;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(HeadRow.prototype, "tableEventsKey", {
    get: function get() {
      return 'headerRow';
    },
    enumerable: true,
    configurable: true
  });

  HeadRow.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        children = _a.children,
        configuration = _a.configuration,
        componentStyle = _a.componentStyle,
        componentStyleProps = _a.componentStyleProps,
        table = _a.table,
        rowIndex = _a.rowIndex,
        headerRow = _a.headerRow,
        columns = _a.columns,
        _b = _a.className,
        rawClassName = _b === void 0 ? '' : _b,
        otherProps = __rest(_a, ["children", "configuration", "componentStyle", "componentStyleProps", "table", "rowIndex", "headerRow", "columns", "className"]);

    var events = this.getEvents(this.eventsForElement, undefined, rowIndex);
    var className = rawClassName + " -ksys-head-row-index-" + rowIndex;
    return react_1.default.createElement("tr", __assign({
      className: className
    }, events, otherProps), headerRow && headerRow.map(function (headerMap, headerMapIndex) {
      var group = headerMap.group,
          column = headerMap.column,
          colSpan = headerMap.colSpan,
          columnIndex = headerMap.columnIndex,
          rowSpan = headerMap.rowSpan;

      if (group) {
        var headCellKey = _this.getHeadCellKey(rowIndex, headerMapIndex, group);

        var headCellStyleProps = _this.getHeadCellStyleProps(rowIndex, group, headerMapIndex);

        return react_1.default.createElement(HeadCell_1.default, __assign({
          scope: "colgroup",
          key: headCellKey
        }, headCellStyleProps, {
          table: table,
          colSpan: colSpan,
          rowSpan: rowSpan,
          rowIndex: rowIndex,
          column: group,
          columnIndex: headerMapIndex
        }));
      }

      if (column && typeof columnIndex === 'number') {
        var headCellKey = _this.getHeadCellKey(rowIndex, columnIndex, column);

        var headCellStyleProps = _this.getHeadCellStyleProps(rowIndex, column, columnIndex);

        return react_1.default.createElement(HeadCell_1.default, __assign({
          scope: "col",
          key: headCellKey
        }, headCellStyleProps, {
          table: table,
          rowIndex: rowIndex,
          column: column,
          colSpan: colSpan,
          rowSpan: rowSpan,
          columnIndex: columnIndex
        }));
      }

      var groupOrColumn = group || column; // not sure what is up here
    }), !headerRow && columns && columns.map(function (column, columnIndex) {
      var headCellKey = _this.getHeadCellKey(rowIndex, columnIndex, column);

      var headCellStyleProps = _this.getHeadCellStyleProps(rowIndex, column, columnIndex);

      return react_1.default.createElement(HeadCell_1.default, __assign({
        scope: "col",
        key: headCellKey
      }, headCellStyleProps, {
        table: table,
        rowIndex: rowIndex,
        column: column,
        columnIndex: columnIndex
      }));
    }));
  };

  HeadRow = __decorate([mobx_react_1.observer], HeadRow);
  return HeadRow;
}(TableComponentBase_1.TableComponentBase);

exports.HeadRow = HeadRow;
exports.default = shared_1.InjectedStyledComponent(HeadRow, HeadRow_meta_1.HEAD_ROW_CATEGORY_KEY, HeadRow_meta_1.HEAD_ROW_PARENT_COMPONENT_KEY, [HeadRow_meta_1.HEAD_ROW_COMPONENT_KEY]);